import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'removeId'
})
export class RemoveIdPipe implements PipeTransform {
  transform(objects: any[], idToremove: number): any {

    if (objects == null) return;

    if (idToremove == null) return objects;

    var out = [];

    for (var i = 0; i < objects.length; i++) {
      if (out.indexOf(objects[i]) == -1) {
        out.push(objects[i]);
      }
      if (objects[i].ID == idToremove) {
        out.splice(out.length - 1, 1);
      }
    }
    return out;
  }
}